
import debounce from "lodash/debounce"
import filter from "lodash/filter"
import sortBy from "lodash/sortBy"
import get from "lodash/get"

export default {
  data: () => ({
    days: [],
    groups: [],
    sessions: [],
    halls: [],
  }),

  async fetch () {
    await this.fetchDays()
    await Promise.all([
      this.fetchSessions(this.activeDay
        ? this.activeDay
        : this.days[0].alias),
      this.fetchGroups(),
      this.fetchHalls(),
    ])
  },

  computed: {
    activeDay () {
      const activeDay = this.days.length ? this.days[0].alias : null
      return this.$route.query.day || activeDay
    },

    search: {
      get () {
        return this.$route.query.search || ""
      },
      set (search) {
        this.$router.push({
          query: {
            ...this.$route.query,
            search: search || undefined,
          },
        })
      },
    },

    activeGroup () {
      const activeGroup = this.groups.length ? this.groups[0].alias : null
      return get(this.$route.query, "group", activeGroup)
    },

    displaySessions () {
      if (!this.activeGroup) return []
      const sessions = this.halls.map(hall =>
        filter(this.sessions, ({ track }) =>
          track.hall.alias === hall.alias && track.group.alias === this.activeGroup,
        ))
      return sortBy(sessions, "start").filter(item => item.length)
    },

    displayHalls () {
      return this.displaySessions.map(session => ({
        ...session[0].track.hall,
        description: session[0].track.description,
      }))
    },
  },

  watch: {
    search: debounce(async function () {
      await this.fetchSessions(this.activeDay
        ? this.activeDay
        : this.days[0].alias)
    }, 300),

    activeDay () {
      this.$router.push({ query: { ...this.$route.query, hall: undefined } })
    },
  },

  methods: {
    async fetchDays () {
      const [res, err] = await this.$api.program.getDays()
      if (err) console.error(err)
      else this.days = this.$api.helpers.getList(res)
    },

    async fetchGroups () {
      const [res, err] = await this.$api.program.getGroups()
      if (err) console.error(err)
      else this.groups = this.$api.helpers.getList(res)
    },

    async fetchSessions (day) {
      const [res, err] = await this.$api.program.getSessions({
        params: { "filter[day]": day, "filter[search]": this.search },
      })
      if (err) console.error(err)
      else this.sessions = this.$api.helpers.getList(res)
    },

    async fetchHalls () {
      const [res, err] = await this.$api.program.getHalls()
      if (err) return console.error(err)
      this.halls = this.$api.helpers.getList(res)
    },
  },
}
